"use client";
import { createTheme } from "@mui/material/styles";
import {
  resmed_soft_black,
  resmed_cool_galaxy_gray_light,
  resmed_blissful_blue,
  text_secondary_main,
} from "@/constants/resmedColours";

const theme = createTheme({
  typography: {
    fontFamily: "var(--font-plus-jakarta-sans), system-ui, sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 600,
      fontSize: "1rem",
    },
  },
  palette: {
    primary: {
      main: resmed_blissful_blue,
    },
    secondary: {
      main: resmed_soft_black,
    },
    text: {
      primary: resmed_soft_black,
      secondary: text_secondary_main,
    },
    action: {
      active: text_secondary_main,
      hover: resmed_cool_galaxy_gray_light,
    },
    background: {
      default: "white",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "0.75rem 1.25rem",
        },
        containedPrimary: {
          backgroundColor: resmed_soft_black,
          color: "white",
          borderRadius: "6.25rem",
          "&:hover": {
            backgroundColor: resmed_soft_black,
            opacity: 0.8,
          },
        },
        containedSecondary: {
          backgroundColor: "white",
          color: resmed_soft_black,
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: resmed_soft_black,
          borderRadius: "6.25rem",
          "&:hover": {
            backgroundColor: "white",
            borderColor: resmed_soft_black,
            opacity: 0.8,
          },
        },
        outlinedSecondary: {
          backgroundColor: "transparent",
          color: resmed_soft_black,
          borderColor: resmed_soft_black,
          borderRadius: "6.25rem",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
            borderColor: resmed_soft_black,
          },
        },
      },
    },
  },
});

export default theme;
